import { useCallback } from 'react';

import type { SessionStorageEntries } from 'lib/storage/sessionStorage';
import { sessionStorage } from 'lib/storage/sessionStorage';

export const useSessionStorage = <K extends keyof SessionStorageEntries>(
  key: K
): [
  SessionStorageEntries[K] | null,
  (value: SessionStorageEntries[K] | null) => void,
] => {
  const updateSessionStorage = useCallback(
    (v: SessionStorageEntries[K] | null) => sessionStorage.setItem(key, v),
    [key]
  );

  return [sessionStorage.getItem(key), updateSessionStorage];
};
